import type { Dispatch, Middleware, UnknownAction } from '@reduxjs/toolkit';
import { fetchUltimasConversas } from './actions';

const DEBOUNCE_MS = 500;
let timer: ReturnType<typeof setTimeout> | null = null;

const scheduleRefetch = (dispatch: Dispatch<UnknownAction>) => {
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    dispatch(fetchUltimasConversas(undefined) as unknown as UnknownAction);
    timer = null;
  }, DEBOUNCE_MS);
};

interface AddMensagemPayload {
  direction?: 'INBOUND' | 'OUTBOUND';
}
interface UpdateConversaPayload {
  status?: 'OPEN' | 'ACTIVE' | 'CLOSED' | 'ARCHIVED';
}

export const homeConversasMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  if (
    typeof action === 'object' &&
    action !== null &&
    'type' in action &&
    typeof (action as { type: unknown }).type === 'string'
  ) {
    const a = action as { type: string; payload?: unknown };

    if (a.type === 'messaging/addMensagem') {
      const p = a.payload as AddMensagemPayload | undefined;
      if (p?.direction === 'INBOUND') {
        scheduleRefetch(store.dispatch);
      }
    } else if (a.type === 'messaging/updateConversa') {
      const p = a.payload as UpdateConversaPayload | undefined;
      if (p?.status === 'CLOSED' || p?.status === 'ARCHIVED') {
        scheduleRefetch(store.dispatch);
      }
    }
  }

  return result;
};
